import { render, staticRenderFns } from "./growthModelEvnParamManagement.vue?vue&type=template&id=3916d61c&scoped=true"
import script from "./growthModelEvnParamManagement.vue?vue&type=script&lang=js"
export * from "./growthModelEvnParamManagement.vue?vue&type=script&lang=js"
import style0 from "./growthModelEvnParamManagement.vue?vue&type=style&index=0&id=3916d61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3916d61c",
  null
  
)

export default component.exports